<template>
  <v-app>
    <GameLayout />
  </v-app>
</template>


<script>
import GameLayout from "./components/GameLayout.vue";
export default {
  components: {
    GameLayout,
  },
  data() {
    return {
      isAuthenticated: false,
      token: ""
    };
  },
};
</script>
